import { StaticMaps } from '@tribeplatform/gql-client/types'
import { useColorScheme } from '@tribeplatform/react-ui-kit/ThemeProvider'

import { Image } from '../../common/components/Image.js'
import { Link } from '../../Link/Link.js'

import { generateGoogleMapsUrl } from './utils.js'

interface Props {
  latitude: number
  longitude: number
  placeId: string
  urls: StaticMaps
}

export const MapImageRenderer = ({
  latitude,
  longitude,
  placeId,
  urls,
}: Props) => {
  const { colorScheme } = useColorScheme()
  const mapUrl = generateGoogleMapsUrl(latitude, longitude, placeId)

  return (
    <Link href={mapUrl} target="_blank" className="w-full h-[200px]">
      <Image
        src={urls?.[colorScheme === 'dark' ? 'darkUrl' : 'lightUrl']}
        alt="Location Map"
        className="h-full w-full object-cover rounded-base"
      />
    </Link>
  )
}
